import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-583a7fbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container d-f flex-d-c" }
const _hoisted_2 = { class: "d-f bg-fff justify-b align-c nav" }
const _hoisted_3 = { class: "d-f align-c" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Preview")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_6 = { class: "m-8 bg-fff" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "Generate DCN")
], -1))
const _hoisted_8 = { class: "search-main d-f p-16" }
const _hoisted_9 = { class: "search-item d-f flex-d-c" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Entity", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Payout Round", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item d-f m-t-16" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item d-f m-t-16" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item d-f m-t-16" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item d-f m-t-16" }, null, -1))
const _hoisted_18 = { class: "content-container bg-fff" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "DCN Template")
], -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Y")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("N")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Y")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("N")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Y")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("N")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Y")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("N")
const _hoisted_28 = { class: "preview-wrapper" }
const _hoisted_29 = {
  key: 0,
  class: "file-name bbac-file-name"
}
const _hoisted_30 = {
  key: 1,
  class: "file-name"
}
const _hoisted_31 = {
  key: 0,
  class: "file-code bbac-file-code"
}
const _hoisted_32 = {
  key: 1,
  class: "file-code"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rate" }, "税率：(System Auto Generate)", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dealer-400-code" }, "经销商代码(System Auto Generate)", -1))
const _hoisted_35 = { class: "party-a" }
const _hoisted_36 = {
  key: 0,
  class: "party-b"
}
const _hoisted_37 = {
  key: 1,
  class: "party-b"
}
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "assessment-period" }, "考核期间：", -1))
const _hoisted_40 = {
  key: 0,
  class: "table-data-wrapper"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  border: "1",
  class: "bbac-table"
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "货物名称"),
    /*#__PURE__*/_createElementVNode("th", null, "折让金额"),
    /*#__PURE__*/_createElementVNode("th", null, "折让税款"),
    /*#__PURE__*/_createElementVNode("th", null, "合计")
  ])
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "table-title-wrapper" }
const _hoisted_44 = { class: "table-title" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-date-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-date" }, "Date 日期：")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-data-wrapper" }, [
  /*#__PURE__*/_createElementVNode("table", {
    border: "1",
    class: "denza-table"
  }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", null, [
          /*#__PURE__*/_createTextVNode("Dealer Name"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("经销商名称")
        ]),
        /*#__PURE__*/_createElementVNode("th"),
        /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, [
          /*#__PURE__*/_createTextVNode("Dealer SWT Code"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("经销商SWT代码")
        ]),
        /*#__PURE__*/_createElementVNode("th")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", {
          colspan: "5",
          class: "sales-incentive"
        }, "Sales Incentive销售折让")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", null, "货物名称（车型名称）"),
        /*#__PURE__*/_createElementVNode("th", null, "折让金额（元）"),
        /*#__PURE__*/_createElementVNode("th", null, "税率"),
        /*#__PURE__*/_createElementVNode("th", null, "折让税款（元）"),
        /*#__PURE__*/_createElementVNode("th", null, "合计Total（元）")
      ])
    ])
  ])
], -1))
const _hoisted_47 = { class: "table-title-wrapper" }
const _hoisted_48 = { class: "table-title" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-date-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-date" }, "Date 日期：")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-data-wrapper" }, [
  /*#__PURE__*/_createElementVNode("table", {
    border: "1",
    class: "fbac-table"
  }, [
    /*#__PURE__*/_createElementVNode("thead", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", null, [
          /*#__PURE__*/_createTextVNode("Dealer Name"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("经销商名称")
        ]),
        /*#__PURE__*/_createElementVNode("th"),
        /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, [
          /*#__PURE__*/_createTextVNode("Dealer SWT Code"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("经销商SWT代码")
        ]),
        /*#__PURE__*/_createElementVNode("th")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", {
          colspan: "5",
          class: "sales-incentive"
        }, "Sales Incentive销售折让")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("th", null, "货物名称（车型名称）"),
        /*#__PURE__*/_createElementVNode("th", null, "折让金额（元）"),
        /*#__PURE__*/_createElementVNode("th", null, "税率"),
        /*#__PURE__*/_createElementVNode("th", null, "折让税款（元）"),
        /*#__PURE__*/_createElementVNode("th", null, "合计Total（元）")
      ])
    ])
  ])
], -1))
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = {
  key: 0,
  class: "party-a-sign bbac-party-a-sign"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_54 = {
  key: 1,
  class: "party-a-sign"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "日期：", -1))
const _hoisted_57 = { class: "party-b-sign" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("乙方：")
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "日期：", -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_movable = _resolveComponent("movable")!
  const _component_movable_panel = _resolveComponent("movable-panel")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb, {
        dataSource: [{name: _ctx.$t('payment.dcnTemplateSet')}]
      }, null, 8, ["dataSource"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "m-r-16",
          onClick: _ctx.doPreview
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "m-r-20",
          onClick: _ctx.onSaveData
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_a_row, {
            type: "flex",
            justify: "space-around",
            align: "middle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11,
                  _createVNode(_component_a_input, {
                    value: _ctx.$route.query.entity,
                    disabled: "",
                    style: {"width":"100px"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_a_input, {
                    value: _ctx.$route.query.payoutRound,
                    disabled: "",
                    style: {"width":"300px"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createVNode(_component_a_form, { class: "form-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "File Name",
            class: "file-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "Use input",
                value: _ctx.state.fileName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.fileName) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "File Code",
            class: "file-code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "Use input",
                value: 'System Auto Generates',
                disabled: true
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "甲方",
            class: "party-a-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "Use input",
                value: _ctx.state.partyAName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.partyAName) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "签章",
            class: "party-a-seal-status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.state.partyASealStatus,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.partyASealStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "Y" }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "N" }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "落款",
            class: "party-a-sign-status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.state.partyASignStatus,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.partyASignStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "Y" }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "N" }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "乙方",
            class: "party-b-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "Use input",
                value: 'System Auto Generates',
                disabled: true
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "签章",
            class: "party-b-seal-status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.state.partyBSealStatus,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.partyBSealStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "Y" }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "N" }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "协议说明",
            class: "protocol-specification"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                placeholder: "Use input",
                rows: 4,
                "auto-size": {minRows: 4, maxRows: 4},
                value: _ctx.state.protocolSpecification,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.protocolSpecification) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "考核期间",
            class: "assessment-period"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "Use input",
                value: 'System Auto Generates',
                disabled: true
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "显示",
            class: "assessment-period-status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.state.assessmentPeriodStatus,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.assessmentPeriodStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "Y" }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "N" }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "销售折让明细表名称",
            class: "table-title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                placeholder: "Use input",
                row: 2,
                "auto-size": {minRows: 2, maxRows: 2},
                value: _ctx.state.tableTitle,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.tableTitle) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "明细表",
            class: "detail-table"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                placeholder: "Use input",
                value: 'System Auto Generates',
                disabled: true
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "补充说明",
            class: "addition-ppecification"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                placeholder: "Use input",
                rows: 4,
                "auto-size": {minRows: 4, maxRows: 4},
                value: _ctx.state.additionSpecification,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.additionSpecification) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.previewPanelVisiable)
      ? (_openBlock(), _createBlock(_component_a_drawer, {
          key: 0,
          title: "Preview",
          placement: "right",
          closable: true,
          visible: _ctx.previewPanelVisiable,
          onClose: _ctx.doClosePreviewPanel,
          width: _ctx.PANEL_WIDTH + 50,
          height: _ctx.PANEL_HEIGHT + 50,
          wrapClassName: "dcn-preview-drawer"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_movable_panel, {
                class: "preview-container",
                itemIsResizable: false,
                w: _ctx.PANEL_WIDTH,
                h: _ctx.PANEL_HEIGHT,
                slotSort: _ctx.slotSort
              }, _createSlots({
                fileName: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "file-name-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.fileName)
                  }, [
                    _createVNode(_component_movable, { ref: "fileNameRef" }, {
                      default: _withCtx(() => [
                        (_ctx.searchParams.entity === 'BBAC')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.state.fileName), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.state.fileName), 1))
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                fileCode: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "file-code-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.fileCode)
                  }, [
                    _createVNode(_component_movable, { ref: "fileCodeRef" }, {
                      default: _withCtx(() => [
                        (_ctx.searchParams.entity === 'BBAC')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, "编号(System Auto Generate)"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_32, "编号："))
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                rate: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "rate-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.rate)
                  }, [
                    _createVNode(_component_movable, { ref: "rateRef" }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                dealer400Code: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "dealer-400-code-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.dealer400Code)
                  }, [
                    _createVNode(_component_movable, { ref: "dealer400CodeRef" }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                partyB: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "party-b-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.partyB)
                  }, [
                    _createVNode(_component_movable, { ref: "partyBRef" }, {
                      default: _withCtx(() => [
                        (_ctx.searchParams.entity === 'BBAC')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, "乙方(System Auto Generate)"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_37, "乙方："))
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                protocolSpecification: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "protocol-specification-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.protocolSpecification)
                  }, [
                    _createVNode(_component_movable, { ref: "protocolSpecificationRef" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          class: _normalizeClass(["protocol-specification", {'bbac-protocol-specification': _ctx.searchParams.entity === 'BBAC'}]),
                          innerHTML: _ctx.state.protocolSpecification
                        }, null, 10, _hoisted_38)
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                detailTable: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "detail-table-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.detailTable)
                  }, [
                    _createVNode(_component_movable, { ref: "detailTableRef" }, {
                      default: _withCtx(() => [
                        (_ctx.searchParams.entity === 'BBAC')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
                          : _createCommentVNode("", true),
                        (_ctx.searchParams.entity === 'DENZA')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.state.tableTitle), 1)
                              ]),
                              _hoisted_45,
                              _hoisted_46
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.searchParams.entity === 'FBAC')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.state.tableTitle), 1)
                              ]),
                              _hoisted_49,
                              _hoisted_50
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                additionSpecification: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "addition-specification-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.additionSpecification)
                  }, [
                    _createVNode(_component_movable, { ref: "additionSpecificationRef" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          class: _normalizeClass(["addition-specification", {'bbac-addition-specification': _ctx.searchParams.entity === 'BBAC'}]),
                          innerHTML: _ctx.state.additionSpecification
                        }, null, 10, _hoisted_51)
                      ]),
                      _: 1
                    }, 512)
                  ], 4)
                ]),
                partyASign: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "party-a-sign-wrapper",
                    style: _normalizeStyle(_ctx.wrapperStyles.partyASign)
                  }, [
                    (_ctx.state.partyASignStatus === 'Y')
                      ? (_openBlock(), _createBlock(_component_movable, {
                          key: 0,
                          ref: "partyASignRef"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.searchParams.entity === 'BBAC')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.state.partyAName), 1),
                                  _hoisted_53
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                  _createElementVNode("p", null, [
                                    _createTextVNode("甲方：" + _toDisplayString(_ctx.state.partyAName), 1),
                                    (_ctx.state.partyASealStatus === 'Y')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, "（公章）"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_56
                                ]))
                          ]),
                          _: 1
                        }, 512))
                      : _createCommentVNode("", true)
                  ], 4)
                ]),
                _: 2
              }, [
                (_ctx.searchParams.entity !== 'BBAC')
                  ? {
                      name: "partyA",
                      fn: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "party-a-wrapper",
                          style: _normalizeStyle(_ctx.wrapperStyles.partyA)
                        }, [
                          _createVNode(_component_movable, { ref: "partyARef" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_35, "甲方：" + _toDisplayString(_ctx.state.partyAName), 1)
                            ]),
                            _: 1
                          }, 512)
                        ], 4)
                      ])
                    }
                  : undefined,
                (_ctx.searchParams.entity !== 'BBAC')
                  ? {
                      name: "assessmentPeriod",
                      fn: _withCtx(() => [
                        (_ctx.state.assessmentPeriodStatus === 'Y')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "assessment-period-wrapper",
                              style: _normalizeStyle(_ctx.wrapperStyles.assessmentPeriod)
                            }, [
                              _createVNode(_component_movable, { ref: "assessmentPeriodRef" }, {
                                default: _withCtx(() => [
                                  _hoisted_39
                                ]),
                                _: 1
                              }, 512)
                            ], 4))
                          : _createCommentVNode("", true)
                      ])
                    }
                  : undefined,
                (_ctx.searchParams.entity !== 'BBAC')
                  ? {
                      name: "partyBSign",
                      fn: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "party-b-sign-wrapper",
                          style: _normalizeStyle(_ctx.wrapperStyles.partyBSign)
                        }, [
                          _createVNode(_component_movable, { ref: "partyBSignRef" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("p", null, [
                                  _hoisted_58,
                                  (_ctx.state.partyBSealStatus === 'Y')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, "（公章）"))
                                    : _createCommentVNode("", true)
                                ]),
                                _hoisted_60
                              ])
                            ]),
                            _: 1
                          }, 512)
                        ], 4)
                      ])
                    }
                  : undefined
              ]), 1032, ["w", "h", "slotSort"])
            ]),
            _createVNode(_component_a_button, {
              type: "primary",
              class: "m-8 preview-save-btn",
              onClick: _ctx.onSave
            }, {
              default: _withCtx(() => [
                _hoisted_61
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["visible", "onClose", "width", "height"]))
      : _createCommentVNode("", true)
  ]))
}